<template>
    <div class="container">
        <div class="placeholder-premium">
            <img
                class="placeholder-premium__icon"
                src="@/assets/images/icons/icon-lock.svg"
                alt="">
            <p class="title--3">{{ $t('feature-only-enable-to-premium-user') }}</p>
            <p>{{ $t("for-more-information-contact") }} <a href="mailto:hello@bloombub.com">hello@bloombub.com</a>.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlaceholderPremiumOnly"
};
</script>
